    <div class="content">
        <b>Getränkehändler und Vertragspartner:</b><br><br>

        {{(config$ | async)?.dealer?.company}}<br>
        {{(config$ | async)?.dealer?.street}}<br>
        {{(config$ | async)?.dealer?.postcode}} {{(config$ | async)?.dealer?.town}}<br><br>
        {{(config$ | async)?.dealer?.owner}}<br><br>
        Telefon: {{(config$ | async)?.dealer?.phone}}<br>
        E-Mail: {{(config$ | async)?.dealer?.email}}<br><br>
        <ng-container *ngIf="((config$ | async)?.dealer?.VATRegistrationNumber?.length ?? 0) > 0">Umsatzsteueridentifikationsnummer gemäß § 27 a Umsatzsteuergesetz: {{(config$ | async)?.dealer?.VATRegistrationNumber}}<br><br></ng-container>
        <ng-container *ngIf="((config$ | async)?.dealer?.commercialRegister?.length ?? 0) > 0">{{(config$ | async)?.dealer?.commercialRegister}}<br><br></ng-container>
        {{(config$ | async)?.dealer?.additionalInformation}}<br><br><br><br>


        <b>Betreiber der Plattform webDrink.de:</b><br><br>

        IndenWare GmbH<br>
        Driedorfstr. 13<br>
        35683 Dillenburg<br><br>

        E-Mail: info@indenware.de
        <br><br>
        Vertretungsberechtigter Geschäftsführer:<br>
        Marc Inden
        <br><br>
        Registergericht: Amtsgericht Wetzlar<br>
        Registernummer: HRB 5669<br>
        Umsatzsteueridentifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE263048731
    </div>
